/**
 * CloseButton - Botón de cierre reutilizable
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import type { CloseButtonProps } from "../../types";

const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => {
    const navigate = useNavigate();

    const handleClick = onClick || (() => navigate(-1));

    return (
        <button
            onClick={handleClick}
            className="absolute top-4 right-4 bg-gray-500 hover:bg-gray-600 text-white font-bold text-xl rounded-full w-8 h-8 flex items-center justify-center z-50"
        >
            ×
        </button>
    );
};

export default CloseButton;
